import axios from 'axios';

async function getContasAPagarConfirmadas(filters: ApiFiltersType, token?: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/contasapagar/curvaabc`,
      params: {
        ...filters,
      }
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export { getContasAPagarConfirmadas };
